import React, { useState, useEffect } from 'react';

import { Container, Grid, Paper, IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { SelectActiveUPITransfer as UPI_ACTIVE } from 'Components/Api/UPITransferSettingsAPI';
import { LOGOUT } from 'ConstComponents';

import DmtIcon from 'Components/DashboardIcon/DmtIcon';
import UPITransferIcon from 'Components/DashboardIcon/UPITransferIcon';
const CustomContainer = HOCLoader(Container);
export const UPITransfer = () => {
    const classes = commonStyle();

    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [NotActiveAPI, setNotActiveAPI] = useState(false);
    const history = useHistory();
    const [ActiveUPIs, setActiveUPI] = useState([]);

    useEffect(() => {
        selectActiveUPI();
    }, []);

    const selectActiveUPI = async () => {
        const response = await UPI_ACTIVE();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            setNotActiveAPI(true);
        }

        let data = JSON.parse(response.data);
        if (data.length <= 0) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            setNotActiveAPI(true);
        }

        if (data.length === 1) {
            handleUPIClick(
                data[0].Name,
                data[0].IsCommonUPI,
                data[0].IsUPITransferWithSender
            ); //,
        }
        setActiveUPI(data);
    };

    const handleUPIClick = (name, IsCommonUPI, IsUPITransferWithSender) => {
        let params = {
            ActiveUPITransferName: name.toLowerCase()
        };

        if (IsCommonUPI === true) {
            let param = {
                ActiveUPITransferName: name
            };

            history.push('/TransferUPI', param);

            return;
        } else if (IsUPITransferWithSender === true) {
            let param = {
                ActiveUPITransferName: name
            };
            history.push('/UPISenderSearch', param);
        } else if (
            name.toLowerCase() === 'CashFree'.toLowerCase() ||
            name.toLowerCase() === 'RazorPay'.toLowerCase() ||
            name.toLowerCase() === 'ICICI_Compisite'.toLowerCase() ||
            name.toLowerCase() === 'InstantPay'.toLowerCase()
        ) {
            history.push('/CM_UPITransfer', params);
            return;
        }
        if (name.toLowerCase() === 'NetLinkUPI'.toLowerCase()) {
            history.push('/MNL_UPITransfer');
            return;
        }

        if (name.toLowerCase() === 'ClickPayUPI'.toLowerCase()) {
            history.push('/CP_UPITransfer');
            return;
        }

        if (name.toLowerCase() === 'APIClubUPI'.toLowerCase()) {
            history.push('/AC_UPITransfer');
            return;
        }

        setIsError(true);
        setSeverity('error');
        setResponseMessage('No active API,Please contact to customer care');
        setNotActiveAPI(true);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            {NotActiveAPI ? (
                <Paper className={classes.PaperStyle}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            Please wait .....
                        </Grid>
                    </Grid>
                </Paper>
            ) : null}

            <Paper className={classes.PaperStyle}>
                <Grid container>
                    {ActiveUPIs.map((upi) => (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={2}
                            xl={2}
                            className="text-center"
                        >
                            <IconButton
                                color="primary"
                                className="dashmenu"
                                // component="div"
                                onClick={() => {
                                    handleUPIClick(
                                        upi.Name,
                                        upi.IsCommonUPI,
                                        upi.IsUPITransferWithSender
                                    );
                                }}
                            >
                                <UPITransferIcon name={upi.DisplayName} />
                            </IconButton>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
